import { Close } from "@mui/icons-material";
import { Box, Card, IconButton, Stack } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";
import { To } from "react-router";

import { AreaCardHeader } from "./AreaCardHeader";
import { AreaCardFragment } from "./fragments.generated";

type AreaCardProps = PropsWithChildren & {
    area: AreaCardFragment;
    areaNameHref: (areaId: string) => To;
    removable?: boolean;
    onRemoveClick?: (areaId: string) => void;
    children: ReactNode;
};

export function AreaCard({ area, removable, onRemoveClick, children, areaNameHref }: AreaCardProps) {
    return (
        <Card
            sx={theme => ({
                border: `1px solid ${theme.palette.divider}`,
                maxWidth: 400,
            })}
        >
            <Stack direction="row" alignItems="center" paddingInline={2} gap={2}>
                <AreaCardHeader area={area} areaNameHref={areaNameHref} />
                {removable && (
                    <Box>
                        <IconButton size="small" onClick={() => onRemoveClick?.(area.id)}>
                            <Close />
                        </IconButton>
                    </Box>
                )}
            </Stack>
            {children}
        </Card>
    );
}
